import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {Map} from "immutable";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import SupplierDetail from "./SupplierDetail";
import SupplierOrders from './SupplierOrders';
import SupplierReceipts from './SupplierReceipts';
import SupplierInvoices from './SupplierInvoices';
import DeleteDialog from '../../../components/dialogs/DeleteDialog';

// Actions
import {changeSupplierStatus, getSupplier, updateSupplier, deleteSupplier, cleanSuppliers} from "../../../actions/suppliers";

class SupplierTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            editMode: false,
            canSubmit: false,
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }
    componentDidMount() {
        this.props.getSupplier(this.props.match.params.supplierId);
    }
    componentWillUnmount() {
        this.props.cleanSuppliers();
    }

    // Tab functions
    getSelectedIndex() {
        const {supplierId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/compras/proveedores/' + supplierId + '/detalle':
                return 0;
            case '/compras/proveedores/' + supplierId + '/pedidos':
                return 1;
            case '/compras/proveedores/' + supplierId + '/albaranes':
                return 2;
            case '/compras/proveedores/' + supplierId + '/facturas':
                return 3;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {supplierId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/compras/proveedores/' + supplierId + '/detalle';
                break;
            case 1:
                route = '/compras/proveedores/' + supplierId + '/pedidos';
                break;
            case 2:
                route = '/compras/proveedores/' + supplierId + '/albaranes';
                break;
            case 3:
                route = '/compras/proveedores/' + supplierId + '/facturas';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // SupplierDetail functions
    handleEditClick = () => {
        this.setState({
            editMode: true
        });
    };
    handleCancelClick = () => {
        this.child.setSupplierState();
        this.setState({
            editMode: false,
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updateSupplier();
        this.setState({
            editMode: false,
            canSubmit: false
        });
    };
    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar proveedor',
                        body: (
                            <DeleteDialog
                                text={ this.props.supplier.get('supplier_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteSupplier(this.props.supplier.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/compras/proveedores');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/compras/resumen">Compras</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/compras/proveedores">Proveedores</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{`[${this.props.supplier.get('supplier_code')}] ${this.props.supplier.getIn(['basic_info', 'name'])}`}</strong>
                            </li>
                        </ol>
                    </div>
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                { !this.state.editMode
                                    ? <div className="title-action">
                                        { this.props.supplier.get('can_delete')
                                            ? <button className="btn btn-danger" onClick={ () => this.openModal('deleteDialog') }>Borrar</button>
                                            : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={ () => this.handleSaveClick()}
                                            disabled={!this.state.canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Pedidos</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 2})}>Albaranes</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 3})}>Facturas</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <div className="panel-body">
                                                { this.props.supplier.get('_id')
                                                    ? <SupplierDetail
                                                        onRef={ref => (this.child = ref)}
                                                        editMode={this.state.editMode}
                                                        supplier={this.props.supplier}
                                                        updateSupplier={this.props.updateSupplier}
                                                        changeSupplierStatus={this.props.changeSupplierStatus}
                                                        canSubmit={this.canSubmit}
                                                    />
                                                    : null
                                                }
                                            </div>
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <SupplierOrders
                                                supplierId={this.props.match.params.supplierId}
                                                status={this.props.supplier.get('status')}
                                                history={this.props.history}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <SupplierReceipts
                                                supplierId={this.props.match.params.supplierId}
                                                status={this.props.supplier.get('status')}
                                                history={this.props.history}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <SupplierInvoices
                                                supplierId={this.props.match.params.supplierId}
                                                status={this.props.supplier.get('status')}
                                                history={this.props.history}
                                            />
                                        </TabPanel>
                                    </div>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const supplierReducer = state.suppliers;

    // Supplier
    let supplier = supplierReducer.get('payload') || Map({});

    if (!(supplier instanceof Map)) {
        supplier = Map({});
    }

    return {
        supplier
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSupplier: (supplierId) => dispatch(getSupplier(supplierId)),
        updateSupplier: (supplierId, supplier) => dispatch(updateSupplier(supplierId, supplier)),
        changeSupplierStatus: (supplierId, status) => dispatch(changeSupplierStatus(supplierId, status)),
        deleteSupplier: (supplierId) => dispatch(deleteSupplier(supplierId)),
        cleanSuppliers: () => dispatch(cleanSuppliers())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierTabs);



// WEBPACK FOOTER //
// ./src/containers/purchases/suppliers/SupplierTabs.js